import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { dec, inc } from 'ramda';
import { useAppDispatch } from '@/store/hooks';
import { setPage } from '@/features/query-builder/queryBuilderSlice';
import {
  useLoadRows_LEGACY,
  useLoadRowsCount_LEGACY,
} from '@/features/query-builder/hooks/LEGACY';
import { setLastUpdateMethod } from '@/features/query-builder-steps/queryBuilderStepsSlice';
import { useDatasourceId } from '@/hooks';
import { useSaveQuerySteps } from '@/features/query-builder/queriesApiSlice';
import { getQueryBuilderSteps } from '@/store-selectors';
import { LAST_UPDATE_METHOD } from '@/features/query-builder-steps/constants';

export const usePagination = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const datasourceId = useDatasourceId();
  const steps = useSelector(getQueryBuilderSteps);
  const { page } = useLoadRows_LEGACY();
  const totalRowCount = useLoadRowsCount_LEGACY() ?? 0;
  const [localPage, setLocalPage] = React.useState(page);

  const [saveQuerySteps, { data }] = useSaveQuerySteps();
  const nextQueryId = data?.queryId;

  React.useEffect(() => {
    setLocalPage(page);
  }, [page]);

  React.useEffect(() => {
    if (nextQueryId) {
      navigate(`/datasources/${datasourceId}/queries/${nextQueryId}`);
    }
  }, [datasourceId, nextQueryId]);

  const totalNumberOfPages =
    Math.ceil(totalRowCount / 100) === 0
      ? '...'
      : Math.ceil(totalRowCount / 100);

  const handlePaginateForward = () => {
    const nextPage = localPage + 1;
    dispatch(setPage(nextPage));
    dispatch(setLastUpdateMethod(LAST_UPDATE_METHOD.rowsResultPagination));
    setLocalPage(inc);

    saveQuerySteps(steps, nextPage);
  };
  const handlePaginateBackward = () => {
    const nextPage = localPage - 1;
    dispatch(setPage(nextPage));
    dispatch(setLastUpdateMethod(LAST_UPDATE_METHOD.rowsResultPagination));
    setLocalPage(dec);

    saveQuerySteps(steps, nextPage);
  };

  return [
    localPage,
    totalNumberOfPages,
    handlePaginateForward,
    handlePaginateBackward,
  ] as const;
};
